import React, { useState } from "react"
import { ButtonField, InputField, SelectField, Multiselect } from '@wk/components-react16';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { API_USER } from '../../core/constants';
import Api from '../../core/api';
import { logUserActivity, Toast, UserActivity } from "../../services"

const AddUser = ({ roleList }: any) => {
    const Schema = yup.object().shape({
        username: yup
            .string()
            .email()
            .trim()
            .required('Please enter username.'),
        password: yup
            .string()
            .trim()
            .required('Please enter password.')
            .min(8, 'Password must be 8 characters long')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[a-z]/, 'Password must contain at least lowercase letter')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[^\w]/, 'Password must contain at least one special character'),
        active: yup.string().required()
    });

    const submit = async (values: any, { resetForm }: any) => {
        if (roleList.filter((item: any) => item.isSelected).length === 0) {
            Toast("Please select atleast one role.", "error")
            return;
        }
        let regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
        if (!regex.test(values.password.trim())) {
            Toast("Password must be 8+ chars, with 1 digit, 1 lowercase, 1 uppercase, and 1 special character", "error")
            return;
        }
        values['roles'] = roleList.filter((item: any) => item.isSelected).map((item: any) => item.id);
        values.active = values.active === 'active' ? true : false;
        values.username = values.username.trim();
        values.password = values.password.trim();
        let userActivity: UserActivity = {
            action: 'Add User Button Click',
            page: 'User Management',
            viewName: 'Add User',
            entityName: values.username
        }
        logUserActivity(userActivity);
        Api.postRequest(API_USER.ADD_USER, values).then(
            (res: any) => {
                if (res.status === 200) Toast("User have been added successfully.", "sucsess")
                else Toast(res.message, "sucsess")
                resetForm();
                roleList.forEach((item: any) => item.isSelected = false);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <Formik
            validationSchema={Schema}
            enableReinitialize={true}
            initialValues={{ username: "", password: "", active: "active" }}
            onSubmit={submit} resetForm
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isValid,
                dirty, }) => (
                <Form onSubmit={handleSubmit}>
                    <div className="wk-row">
                        <div className="wk-col-6">
                            <InputField
                                label="Email ID"
                                labelFor="username-1"
                                size="small" indicator="required"
                                status={!!errors.username ? "error" : "none"}
                                errors={!!errors.username ? [{
                                    label: errors.username,
                                    labelId: 'label-error-id-1',
                                }] : []}>
                                <input
                                    type="text"
                                    id="username-1"
                                    name="username"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.username}
                                    placeholder="Enter emailid"
                                    autoComplete="off"
                                />
                            </InputField>
                            <InputField
                                label="Password"
                                labelFor="password-1"
                                size="small" indicator="required"
                                status={!!errors.password ? "error" : "none"}
                                errors={!!errors.password ? [{
                                    label: errors.password,
                                    labelId: 'label-error-id-2',
                                }] : []}>
                                <input
                                    type="password"
                                    id="password-1"
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.password}
                                    placeholder="Enter password"
                                    autoComplete="off"
                                />
                            </InputField>
                        </div>
                        <div className="wk-col-6">
                            <Multiselect
                                items={roleList}
                                pillLabel="Roles selected"
                                placeholder="Choose Role"
                                size="small"
                                label="Role"
                                indicator="required"
                                /* status={roleList.filter((item: any) => item.isSelected).length === 0 ? "error" : "none"}
                                errors={roleList.filter((item: any) => item.isSelected).length === 0 ? [{
                                    label: 'Please select atleast one role.',
                                    labelId: 'label-error-id-3',
                                }] : []} */></Multiselect>
                            <SelectField
                                label="Status"
                                labelFor="select-id-1"
                                size="small" indicator="required">
                                <select id="select-id-1" name="active" value={values.active} onChange={handleChange}>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </SelectField>
                        </div>
                    </div>
                    <div className="wk-row">
                        <div className="wk-col-12 text-right">
                            <ButtonField size={'small'}>
                                <button type="submit" disabled={!(dirty && isValid)}>
                                    Add User
                                </button>
                            </ButtonField>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default AddUser;
